import { Asset } from '@24i/nxg-sdk-photon/src/models/asset';
import { MapTriggerFunction, TealiumResultPayload } from '../types';

const mapAssetTags = (asset: Asset): string => (asset.tags ?? []).join(', ');

const mapAssetCategories = (asset: Asset): string =>
    (asset.genres ?? [])
        .map((genre) => genre.label)
        .filter(Boolean)
        .join(', ');

export const mapAsset: MapTriggerFunction = (
    _triggerName,
    payload,
    dataMapper
): TealiumResultPayload => {
    const asset = payload.payload.asset || payload.payload.params?.asset;
    if (!asset) return {};
    const { externalId, seriesName } = asset;

    return {
        canonical_url: 'N/A', // cannot productize
        video_series_title: seriesName || undefined,
        byline: dataMapper.entity,
        pub_date: 'N/A',
        article_uid: externalId || 'N/A',
        tags: mapAssetTags(asset) || 'N/A',
        categories: mapAssetCategories(asset) || 'N/A',
    };
};
